export default __webpack_public_path__ + "static/media/b16.eccd6566.png";